import React from "react";
import {
    BulkWorkflowOperation,
    BulkWorkflowOperationConfig
} from "src/components/common/bulk-workflow-operation";
import {
    clientId,
    recipeId,
    program,
    BULK_REDRIVE_CSV_MAX_ROWS,
    SAMPLE_BULK_REDRIVE_RECORDS_INPUT,
    SAMPLE_BULK_REDRIVE_RECORDS_INPUT_FILE,
    BULK_REDRIVE_README_INSTRUCTIONS,
    BULK_REDRIVE_README_COLUMN_SCHEMA,
    BULK_REDRIVE_FILE_EXAMPLE,
    BULK_REDRIVE_OUTPUT_EXAMPLE,
    BULK_REDRIVE_RESULT_TEXT
} from "src/constants/redrive-workflow-instance";

const bulkRedriveConfig: BulkWorkflowOperationConfig = {
    operationType: 'redrive',
    operationDisplayName: 'Redrive',
    clientId,
    recipeId,
    program,
    maxRows: BULK_REDRIVE_CSV_MAX_ROWS,
    sampleInput: SAMPLE_BULK_REDRIVE_RECORDS_INPUT,
    sampleInputFileName: SAMPLE_BULK_REDRIVE_RECORDS_INPUT_FILE,
    readmeInstructions: BULK_REDRIVE_README_INSTRUCTIONS,
    readmeColumnSchema: BULK_REDRIVE_README_COLUMN_SCHEMA,
    fileExample: BULK_REDRIVE_FILE_EXAMPLE,
    outputExample: BULK_REDRIVE_OUTPUT_EXAMPLE,
    resultText: BULK_REDRIVE_RESULT_TEXT,
    requiredColumns: ['reDriveStep']
};

export function BulkRedriveWorkflowInstance() {
    return <BulkWorkflowOperation config={bulkRedriveConfig} />;
}